const ExcludedCategoryIdList = [
  232291, 233808, 233809, 240624, 240626, 239509, 233810, 240627, 236008,
  236009, 240623, 237708, 237729, 155042, 233811, 233812, 239508, 236010,
  236011, 237730, 235508, 235510, 237732, 237733, 57924, 14355, 31456, 3304,
  3485, 19295, 293156, 57448, 57441, 253165, 57435, 57427, 101043, 55760, 27726,
  326656, 198951,
];

export default ExcludedCategoryIdList;
